import React, { useState } from 'react';

const StayInLoopBottomSheet = ({
    onClose = () => { },
    onSubmit = async (email) => {
        console.log('Stay in loop email:', email);
    }
}) => {
    const [email, setEmail] = useState('');
    const [isClosing, setIsClosing] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleClose = () => {
        setIsClosing(true);
        setTimeout(() => onClose(), 280);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        const trimmed = email.trim();
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(trimmed)) {
            setError('Enter a valid email');
            return;
        }
        try {
            setSubmitting(true);
            await onSubmit(trimmed);
            handleClose();
        } catch (err) {
            setError('Something went wrong. Try again.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-end md:items-end justify-center bg-black/50 backdrop-blur-sm"
            onClick={handleClose}
        >
            <div
                onClick={(e) => e.stopPropagation()}
                className={`w-full md:w-[90%] lg:w-[75%] xl:w-[70%] max-w-[1500px] bg-white dark:bg-[#1E1E1E] rounded-t-[48px] md:rounded-t-[48px] px-6 md:px-24 pt-14 md:pt-12 pb-12 md:pb-16 shadow-xl transition-transform
                    ${isClosing ? 'animate-slide-down' : 'animate-slide-up'}`}
            >
                <form onSubmit={handleSubmit} className="max-w-2xl mx-auto flex flex-col items-center text-center">
                    <h1 className="text-2xl md:text-4xl font-semibold tracking-tight text-black dark:text-white">
                        Stay in the Loop!
                    </h1>
                    <p className="mt-2 text-base md:text-lg leading-relaxed text-black/80 dark:text-white/80 px-2">
                        Be the first to know when new content is released. Enter
                        your email below, and we’ll notify you as soon as the next
                        block goes live!
                    </p>

                    <div className="w-full mt-8">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="w-full rounded-xl px-4 py-3 outline-none placeholder:text-[#7C8BA0] 
               bg-[#F5F9FE] dark:bg-white 
               text-black dark:text-black
               border border-gray-200 dark:border-0"
                        />
                        {error && (
                            <div className="mt-2 text-sm text-red-600 dark:text-red-400">{error}</div>
                        )}
                    </div>

                    <button type="submit" className="btn-primary w-full mt-8" style={{ borderRadius: 15 }}>
                        {submitting ? 'Submitting...' : 'Submit'}
                    </button>
                    <button
                        type="button"
                        onClick={handleClose}
                        className="mt-6 text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 transition"
                    >
                        Close
                    </button>
                </form>
            </div>
        </div>
    );
};

export default StayInLoopBottomSheet;
